import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Switch, Route, Redirect } from 'react-router-dom'

import { getMe } from 'utils/auth'


const ProtectedRoute = ({ ...props, allowedRoles, allowedRole }) => {
  const user = getMe()
  if (user && (
    (allowedRole && user.role === allowedRole) ||
    (Array.isArray(allowedRoles) && allowedRoles.includes(user.role))
  )) {
    return <Route {...props} />
  }
  const propsWithoutComponent = { ...props }
  delete propsWithoutComponent['component']
  
  return <Route {...propsWithoutComponent} render={() => <Redirect to='/dashboard' />} />
}


export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/utils/ProtectedRoute.jsx